module.exports = __webpack_public_path__ + "static/media/learn.1c247e68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/learn.svg
// module id = 282
// module chunks = 0